import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthCoverBgSignIn() {
	return <AuthShell variant="cover-bg"><AuthForm variant="cover-bg" mode="sign-in" /></AuthShell>;
}

export default AuthCoverBgSignIn;
